import { Helmet } from "react-helmet-async";

interface SEOProps {
    title: string;
    description: string;
    canonical?: string;
    noIndex?: boolean;
}

export const SEO = ({
    title,
    description,
    canonical,
    noIndex = false,
}: SEOProps) => (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />

        {canonical && <link rel="canonical" href={canonical} />}

        {noIndex && (
            <meta name="robots" content="noindex, nofollow" />
        )}
    </Helmet>
);